//
// Module for the Counseling Appointments Edit view
//
rs.module("content/fund/counselingappointments/index",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {
            var filterForm = $.js(jsSelectors.filterForm);
            var forCancellation = filterForm.js(jsSelectors.forCancellation);
            var appointmentStatus = filterForm.js(jsSelectors.appointmentStatus);
            var appointmentStatusSelectHelper = selectHelper.getHelper(appointmentStatus);

            forCancellation.change(setAppointmentStatusEnabled);
            setAppointmentStatusEnabled();

            function setAppointmentStatusEnabled() {
                var checked = forCancellation.is(':checked');
                if (checked) {
                    appointmentStatusSelectHelper.setValue(null);
                }
                appointmentStatusSelectHelper.setDisabled(checked);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);